const editBulkOrderModule = {
    namespaced: true,
    persistent: true,
    state: {
        bulkOrderId: null,
        data: {}
    },
    mutations: {
        setBulkOrderId(state, orderId) {
            state.bulkOrderId = orderId;
        },
        setData(state, data) {
            state.data = data;
        },
        deleteOrder(state, payload) {
            const orders = state.data[payload.userId][payload.warehouseId].filter(order => order.index !== payload.index)
            state.data[payload.userId][payload.warehouseId] = orders
        },
        addProduct(state, payload) {
            const order = state.data[payload.userId][payload.warehouseId].find(order => order.index === payload.index)
            const orderIndex = state.data[payload.userId][payload.warehouseId].indexOf(order);

            const products = state.data[payload.userId][payload.warehouseId][orderIndex].order;
            const product = products.find(product => product.external_id === payload.product.external_id);
            if (!product || product.quantity < 1) {
                payload.product.quantity = 1;
                state.data[payload.userId][payload.warehouseId][orderIndex].order.push(payload.product);
            }
        },
        addRecipient(state, payload) {
            const order = state.data[payload.userId][payload.warehouseId].find(order => order.index === payload.index)
            const orderIndex = state.data[payload.userId][payload.warehouseId].indexOf(order);

            const recipients = state.data[payload.userId][payload.warehouseId][orderIndex].recipients;
            const recipient = recipients.find(recipient => recipient.address_id === payload.recipient.address_id);
            if (!recipient) {
                state.data[payload.userId][payload.warehouseId][orderIndex].recipients.push(payload.recipient);
            }
        },
        changeProductQuantity(state, payload) {
            const order = state.data[payload.userId][payload.warehouseId].find(order => order.index === payload.index)
            const orderIndex = state.data[payload.userId][payload.warehouseId].indexOf(order);

            const product = state.data[payload.userId][payload.warehouseId][orderIndex].order.find(product => product.external_id === payload.product.external_id);
            const productIndex = state.data[payload.userId][payload.warehouseId][orderIndex].order.indexOf(product);

            product.quantity = payload.quantity;
            state.data[payload.userId][payload.warehouseId][orderIndex].order[productIndex] = product;
        },
        changeRecipient(state, payload) {
            const order = state.data[payload.userId][payload.warehouseId].find(order => order.index === payload.index)
            const orderIndex = state.data[payload.userId][payload.warehouseId].indexOf(order);

            const recipient = state.data[payload.userId][payload.warehouseId][orderIndex].recipients.find(recipient => recipient.address_id === payload.recipient.address_id);
            const recipientIndex = state.data[payload.userId][payload.warehouseId][orderIndex].recipients.indexOf(recipient);

            state.data[payload.userId][payload.warehouseId][orderIndex].recipients[recipientIndex] = recipient;
        },
        removeProduct(state, payload) {
            const order = state.data[payload.userId][payload.warehouseId].find(order => order.index === payload.index)
            const orderIndex = state.data[payload.userId][payload.warehouseId].indexOf(order);

            const products = state.data[payload.userId][payload.warehouseId][orderIndex].order.filter(product => product.external_id !== payload.product.external_id);
            state.data[payload.userId][payload.warehouseId][orderIndex].order = products;
        },
        removeRecipient(state, payload) {
            const order = state.data[payload.userId][payload.warehouseId].find(order => order.index === payload.index)
            const orderIndex = state.data[payload.userId][payload.warehouseId].indexOf(order);

            const recipients = state.data[payload.userId][payload.warehouseId][orderIndex].recipients.filter(recipient => recipient.address_id !== payload.recipient.address_id);
            state.data[payload.userId][payload.warehouseId][orderIndex].recipients = recipients;
        },
        reset(state) {
            state.bulkOrderId = null;
            state.data = {};
        }
    },
    getters: {
        getBulkOrderId: state => {
            return state.bulkOrderId;
        },
        getData: state => {
            return state.data;
        },
        isValid: state => payload => {
            try {
                const orders = state.data[payload.userId][payload.warehouseId];
                for (let i = 0; i < orders.length; i++) {
                    const order = orders[i];
                    if (order.order.length < 1 || order.order.find(o => o.quantity < 1)) return false;
                    if (order.recipients.length < 1 || order.recipients.find(r => !r.email || !r.phone)) return false;
                }
                return true;
            } catch (e) {
                return false;
            }
        },
        getProducts: state => payload => {
            return state.data[payload.userId][payload.warehouseId].find(order => order.index === payload.index).order;
        },
        getRecipientsOfOrder: state => payload => {
            return state.data[payload.userId][payload.warehouseId].find(order => order.index === payload.index).recipients;
        },
        getRecipientsOfBulkOrder: state => payload => {
            const recipients = [];
            state.data[payload.userId][payload.warehouseId].forEach(order => {
                order.recipients.forEach(recipient => {
                    recipients.push(recipient)
                })
            })
            return recipients;
        }
    }
}

export default editBulkOrderModule;
